import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/pages/About.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/pages/Contact.vue')
    },
    {
        path: '/programs',
        name: 'Programs',
        component: () => import('../views/pages/Programs.vue')
    },
    {
        path: '/articles',
        name: 'Articles',
        component: () => import('../views/pages/Articles.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/app/Login.vue')
    },
    {
        path: '/signup',
        name: 'Signup',
        component: () => import('../views/app/Signup.vue')
    },
    {
        path: '*',
        name: 'Not Found',
        component: () => import('../views/etc/404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if(store.state.overlay){
        store.commit('toggleOverlay')
        next()
    }
    next()
})

export default router